import { Card, CardProps, Box, BoxProps } from '@blockanalitica/ui';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface CardListProps extends CardProps {
  header?: ReactNode;
  children: ReactNode;
}

const Header = styled(Box)<BoxProps>`
  ${({ theme }) => css`
    border-top-left-radius: ${theme.sizes['0']};
    border-top-right-radius: ${theme.sizes['0']};
    padding: ${theme.space['s']};
    background-color: ${theme.colors.hype.background100};
  `}
`;

const Body = styled(Box)<BoxProps>`
  ${({ theme }) => css`
    border-bottom-left-radius: ${theme.sizes['0']};
    border-bottom-right-radius: ${theme.sizes['0']};
    padding: ${theme.space['s']};
  `}
`;

export default function HypeCard({ children, header, ...rest }: CardListProps) {
  return (
    <Card {...rest} variant="hypeCard">
      {header ? <Header>{header}</Header> : null}
      <Body>{children}</Body>
    </Card>
  );
}
